<template>

	<div class="page-content">
	<div class="content-wrapper">
	<div class="content">

	<div class="ph_dashboard">

		<div class="row">
			<div class="col-sm-6 col-xl-3">
				<StatBlock :data="block_1"></StatBlock>
			</div>
			<div class="col-sm-6 col-xl-3">
				<StatBlock :data="block_2"></StatBlock>
			</div>
			<div class="col-sm-6 col-xl-3">
				<StatBlock :data="block_3"></StatBlock>
			</div>
			<div class="col-sm-6 col-xl-3">
				<StatBlock :data="block_4"></StatBlock>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col-sm-12 col-xl-9">
			<MultiSellout></MultiSellout>
		</div>
		<div class="col-sm-12 col-xl-3">
			Suite
		</div>
	</div>

	</div>
	</div>
	</div>

</template>

<script>

// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import StatBlock from '@/components/Datastat/Block.vue'
import MultiSellout from '@/components/Datastat/MultiSellout.vue'

const axios = require('axios');

export default {
 name: 'dashboard',
 data() {
	 return {
		 block_1: {
			 id: "block_1",
			 value: 10,
			 label: "Label 1",
			 legend: "Legende 1",
			 type: "areaChart",
			 class: "bg-indigo-400 has-bg-image"
		 },
		 block_2: {
			 id: "block_2",
			 value: 10,
			 label: "Label 1",
			 legend: "Legende 1",
			 type: "barChart",
			 class: "bg-blue-400 has-bg-image"
		 },
		 block_3: {
			 id: "block_3",
			 value: 10,
			 label: "Label 1",
			 legend: "Legende 1",
			 type: "lineChart",
			 class: "bg-green-400 has-bg-image"
		 },
		 block_4: {
			 id: "block_4",
			 value: 10,
			 label: "Label 1",
			 legend: "Legende 1",
			 type: "barChart",
			 class: "bg-pink-400 has-bg-image"
		 },
		 name: "test"
	 }
 },
 components: {
   HelloWorld,
	 StatBlock,
	 MultiSellout
 },
 mounted: function() {
	 window.App.initBeforeLoad();
	 window.App.initCore();
	 window.App.initAfterLoad();
 }
}

</script>

<style type="text/css">

	@import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900');

	body {
	  padding: 10px;
    background-color: rgb(245, 245, 245);
	  font-family: sans-serif;
	}
	.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
	  letter-spacing: 0px;
	}

</style>
